import React from 'react';
import classNames from 'classnames';
import { object } from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import CustomOrder from '../../CustomOrder';
import ContactSellerBtn from '../../ContactSellerBtn';
import {
    reportCustomOrderClick,
    reportCustomOrderClose,
    reportCustomOrderSubmitSuccess,
    reportSendMessageClick,
    reportSendMessageSubmitSuccess
} from '../utils';
import { COPY_ROOT } from '../constants';

import './style.scss';

const PopoverContent = (props, { biEvents }) => (
    <div>
        <p className={classNames('title', 'tbody-5')}>
            <b><I18n k={`${COPY_ROOT}.popover.title`}/></b>
        </p>
        <CustomOrder showArrow
            titleKey={`${COPY_ROOT}.popover.get_a_quote`}
            onSubmitSuccess={() => reportCustomOrderSubmitSuccess(biEvents)}
            onClose={() => reportCustomOrderClose(biEvents)}
            onReportClick={() => reportCustomOrderClick(biEvents)}/>
        <ContactSellerBtn showArrow
            onReportClick={() => reportSendMessageClick(biEvents)}
            onSubmitSuccess={() => reportSendMessageSubmitSuccess(biEvents)}
            titleKey={`${COPY_ROOT}.popover.contact_seller`}/>
    </div>
);

PopoverContent.contextTypes = {
    biEvents: object
};

export default PopoverContent;
